// Auto-generated file - Do not edit manually
export const APP_VERSION = {
  frontend: '2.18.1-RC',
  buildDate: '2026-10-30',
  environment: 'production'
};
